import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../Context/AuthContext';

const ProtectedRoute = ({ children }) => {
    const { isLoggedIn } = useAuth();

    console.log(isLoggedIn);

    if (isLoggedIn === null) {
        return <div>Authenticating...</div>;
    }

    if (!isLoggedIn) {
        return <Navigate to="/admin/login" />;
    }    
    
    return children;
};

export default ProtectedRoute;